import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import moment from 'moment';
import { getnftlist } from '../../actions/users';

const NFTList = () => {
    const [userdet, setUser] = useState();

    useEffect(() => {
        getCatorylist();
    }, [])
    const getCatorylist = async () => {
        var postdata={
          id:"0000"
        }
        var test = await getnftlist(postdata);
        setUser(test.userValue);
    }
    function editR(id) {
        if(id!='') {
            window.location.href="/editnft/"+id;
        }   
    }
    const config = {
        page_size: 5,
        length_menu: [10, 20, 50],
        filename: "Users",
        no_data_text: "No user found!",
    
        language: {
          length_menu: "Show _MENU_ result per page",
          filter: "Filter in records...",
          info: "Showing _START_ to _END_ of _TOTAL_ records",
          pagination: {
            first: "First",
            previous: <> Previous </>,
            next: <>Next</>,
            last: "Last",
          },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
        defaultSortAsc: true,
    };
    const columns = [
        {
          key: "ind",
          text: "SNO",
          className: "name",
          align: "center",
          sortable: false,
          cell: (row, index, column, id) => <p className='text-center exchange_table_values'>{index + 1}</p>,
        },
        {
          key: "details",
          text: "Details",
          className: "Name",
          align: "center",
          sortable: false,
          cell: (val) => <p className='text-center exchange_table_values'>{val.details}</p>,
        },
          {
            key: "nfttag",
            text: "Tag",
            className: "Name",
            align: "center",
            sortable: false,
            cell: (val) => <p className='text-center exchange_table_values'>{val.nfttag}</p>,
          },
          {
              text: "Date",
              className: "Date",
              align: "center",
              sortable: false,
              cell:record=>
                 <div><p className='text-center exchange_table_values'>{ moment(record.Date).format('MMMM,Do YYYY, hh:mm A')}</p></div>
              },
         
          {
            key: "action",
            text: "Action",
            className: "action",
            width: 100,
            align: "center",
            sortable: false,
            cell: record => {
                    return (
                    <div className='text-center exchange_table_values'>
                    <button
                            data-toggle="modal"
                            data-target="#update-template-modal"
                            className="btn btn-primary btn-sm"
                            onClick={() => editR(record._id)}
                            
                            style={{marginRight: '5px'}}>
                            <i className="fa fa-edit"></i>
                        </button>
                    </div>
                );
            }
        },
        ];
  return (
    <>
        <Container fluid className="common_bg position-relative">
            <div className="liner"></div>
            <Row>
                <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                    <Sidebar />
                </Col>
                <Col xl={10} lg={12}>
                    <Header title={'NFT Tag List'} />

                    <div className="common_page_scroller mt-5 pe-2">
                        <div className="page_header">
                            <h2>NFT Tag List</h2>
                        </div>
                        <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                            <ReactDatatable
                                config={config}
                                records={userdet}
                                columns={columns}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </>
  )
}

export default NFTList